import { render } from "./OneRentalSystemComponent.vue?vue&type=template&id=6bd18b06&scoped=true"
const script = {}

import "./OneRentalSystemComponent.vue?vue&type=style&index=0&id=6bd18b06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd18b06"]])

export default __exports__